<template>
  <div class="content">
    <div class="title-text">
      <p class="title">Artist Team</p>
      <p class="subtitle">
        Manage your artist's team.
      </p>
    </div>
    <div class="content-body">
      <div class="artist-team-card">
        <div class="card-content">
          <div class="table-container">
            <table class="users-table">
              <thead>
                <tr class="head">
                  <th>
                    <div class="th-content">
                      <span>Email</span>
                    </div>
                  </th>
                  <th>
                    <div class="th-content">
                      <span>Role</span>
                    </div>
                  </th>
                  <th>
                    <div class="th-content actions">
                      <span>Actions</span>
                    </div>
                  </th>
                  <th>
                    <div class="th-content invitation">
                      <span>Invitation</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="au in artist_users" :key="au.id" class="row">
                  <td class="email">
                    <span v-if="au.team_user">{{ au.team_user.email }}</span>
                    <span
                      v-if="au.team_user && au.team_user.user_id === user.id"
                      class="you-text"
                    >
                      (you)
                    </span>
                  </td>
                  <td class="role">
                    <span>{{ au.role }}</span>
                  </td>
                  <td class="actions">
                    <div class="actions-container">
                      <span v-if="artist.billing_user_id === au.user_id">
                        Billing user can't be removed
                      </span>
                      <button
                        v-else-if="au.user_id !== user.id"
                        @click="removeUserFromArtist(au)"
                      >
                        <span>Remove</span>
                        <RemoveIcon />
                      </button>
                      <template v-else>
                        <span v-if="artist_users.length === 1">
                          You can't remove yourself.
                        </span>
                        <button v-else @click="leaveArtist(au)">
                          <span>Leave</span>
                          <RemoveIcon />
                        </button>
                      </template>
                    </div>
                  </td>
                  <td class="actions invitation">
                    <div class="actions-container">
                      <button
                        v-if="
                          au.user &&
                            au.user.invitation_pending &&
                            au.user.invitation
                        "
                        @click="
                          doCopy(
                            formatInvitationLink(au.user.invitation),
                            'Invitation Link'
                          )
                        "
                        class="button-default"
                      >
                        <span>Copy Invitation Link</span>
                        <CopyIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="invite-user-box">
            <div class="box-header">
              <UserPlusIcon />
              <span>Invite User</span>
            </div>
            <div class="box-content">
              <span class="box-text">
                Invite your team to manage and create smart links for this
                artist.
              </span>
              <div class="subdomain-input">
                <label>
                  <span class="label">Email address</span>
                  <input
                    v-model="invite_user_email"
                    type="text"
                    placeholder="Please enter email address"
                  />
                </label>
              </div>
              <button
                @click="inviteUserToArtist"
                :disabled="!invite_user_email"
                class="button-default"
              >
                <span>Invite user</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SnackBar>
      <template v-slot:icon>
        <CopyIcon />
      </template>
    </SnackBar>
  </div>
</template>

<script>
import UserPlusIcon from "../../../../public/img/icons/user-plus.svg";
import RemoveIcon from "../../../../public/img/icons/remove.svg";
import CopyIcon from "../../../../public/img/icons/copy.svg";
import { M_DELETE_ARTIST_USER, M_INVITE_USER, Q_ARTIST_USERS } from "@/graphql";
import Swal from "sweetalert2";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import "@/assets/scss/custom/vendors-extensions/_braintree.scss";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  name: "TeamMembers",
  components: {
    UserPlusIcon,
    RemoveIcon,
    SnackBar,
    CopyIcon
  },
  data() {
    return {
      artist_users: [],
      invite_user_email: null
    };
  },
  apollo: {
    artist_users: {
      query: Q_ARTIST_USERS,
      variables() {
        return {
          artist_id: this.artist.id
        };
      },
      result({ data }) {
        this.artist_users = data.artist_users;
      }
    }
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    },
    snack() {
      return this.$store.getters.getSnack;
    }
  },
  methods: {
    formatInvitationLink(val) {
      return val
        ? `https://artisthub.io/complete-registration?invitation=${val}`
        : "";
    },
    doCopy(text, type) {
      const vm = this;
      this.$copyText(text).then(
        function(e) {
          console.log(e);
          if (type) {
            vm.$store.dispatch("snack", {
              text: `${type} copied to clipboard`
            });
          }
        },
        function(e) {
          console.log("Can not copy", text, type, e);
        }
      );
    },
    async inviteUserToArtist() {
      try {
        await this.$apollo.mutate({
          mutation: M_INVITE_USER,
          client: "localClient",
          variables: {
            artist_id: this.artist.id,
            email: this.invite_user_email.toLowerCase().trim(),
            coupon: ""
          }
        });

        await this.$apollo.queries.artist_users.refetch();
        await this.$store.dispatch("snack", {
          text: "Success! User invite has been sent!"
        });
        // document.location = document.location;
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
        });
      }
    },
    async removeUserFromArtist(artist_user) {
      const confirmDelete = await Swal.fire({
        title: "Remove this user?",
        text: "This user will lose access to this artist.",
        type: "warning",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, remove access",
        cancelButtonText: "No, keep it",
        confirmButtonClass: "button-danger big",
        cancelButtonClass: "button-secondary big",
        buttonsStyling: false
      });

      if (confirmDelete.value) {
        try {
          await this.$apollo.mutate({
            mutation: M_DELETE_ARTIST_USER,
            variables: {
              artist_users_id: artist_user.id
            }
          });
          await this.$apollo.queries.artist_users.refetch();
          await this.$store.dispatch("snack", {
            text: "Success! User has been removed from the artist."
          });
        } catch (err) {
          console.log(err);
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
          });
        }
      } else {
        await this.$store.dispatch("snack", {
          text: "Cancelled! User access is safe."
        });
      }
    },
    async leaveArtist(artist_user) {
      const confirmDelete = await Swal.fire({
        title: "Leave Artist?",
        text: "You will lose access to this artist.",
        type: "warning",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, leave artist",
        cancelButtonText: "No, stay",
        confirmButtonClass: "button-danger big",
        cancelButtonClass: "button-secondary big",
        buttonsStyling: false
      });

      if (confirmDelete.value) {
        try {
          await this.$apollo.mutate({
            mutation: M_DELETE_ARTIST_USER,
            variables: {
              artist_users_id: artist_user.id
            }
          });
          await this.$store.dispatch("snack", {
            text: "Success! You left the artist."
          });
          if (this.user.artists.length) {
            await this.$store.dispatch("removeArtist", artist_user.artist_id);
            await this.$store.dispatch("setArtist", this.user.artists[0]);
          }
          document.location = "/links"; // vue router doesn't reset apollo subscription
        } catch (err) {
          console.log(err);
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
          });
        }
      } else {
        await this.$store.dispatch("snack", {
          text: "Cancelled! Artist access is safe."
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.artist-team-card {
  padding: 24px;
  /* BG/type2 */
  background: $bg-type-2;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: white;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
  }
  .card-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0 6px;
      margin-top: 6px;
      thead {
        tr {
          th {
            padding: 18px 18px 6px 0;
            /* 12/SemiBold */
            font-weight: 600;
            font-size: 12px;
            line-height: 15px;
            /* Text/type0 */
            color: $text-type-0;
            &:first-child {
              padding-left: 18px;
            }
            .th-content {
              display: flex;
              align-items: center;
              &.actions {
                //justify-content: flex-end;
                padding-left: 6px;
              }
            }
            svg {
              margin-left: 5px;
              path {
                fill: $text-type-0;
              }
            }
          }
        }
      }
      tbody {
        tr {
          /* BG/type1 */
          background: $bg-type-1;
          //border-bottom: 6px solid $bg-type-2;
          .email {
            border-radius: 10px 0 0 10px;
            padding-left: 18px;
            span {
              /* 14/SemiBold */
              font-size: 14px;
              line-height: 28px;
              /* White */
              color: white;
              mix-blend-mode: normal;
              opacity: 0.9;
              &.you-text {
                margin-left: 6px;
                font-weight: 600;
              }
            }
          }
          .actions {
            .actions-container {
              display: flex;
              //justify-content: flex-end;
              span {
                padding-left: 6px;
              }
              button {
                display: flex;
                align-items: center;
                background: none;
                border: none;
                &:focus {
                  outline: none;
                  padding-left: 0px;
                }
                span {
                  color: $purple;
                  /* 14/SemiBold */
                  font-weight: 600;
                  font-size: 14px;
                  line-height: 22px;
                }
                svg {
                  width: 18px;
                  margin-left: 8px;
                  path {
                    fill: $purple;
                  }
                }
              }
            }
          }
          .invitation {
            border-radius: 0 10px 10px 0;
            button {
              display: flex;
              align-items: center;
              background: none;
              border: none;
              padding: 0;
              &:focus {
                outline: none;
              }
              span {
                color: $purple;
                /* 14/SemiBold */
                font-weight: 600;
                font-size: 14px;
                line-height: 22px;
                padding-left: 0 !important;
              }
              svg {
                width: 18px;
                margin-left: 8px;
                path {
                  fill: $purple;
                }
              }
            }
          }
          td {
            //padding: 18px;
            //border: solid 1px transparent;
            margin-bottom: 6px;
            /* 14/Regular */
            font-size: 14px;
            line-height: 28px;
            /* White */
            color: white;
            mix-blend-mode: normal;
            opacity: 0.9;
          }
        }
      }
    }

    .invite-user-box {
      margin-top: 24px;
      width: 100%;
      /* BG/type1 */
      border: 2px solid $bg-type-1;
      box-sizing: border-box;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      .box-header {
        width: 100%;
        padding: 18px 24px;
        display: flex;
        align-items: center;
        /* BG/type1 */
        background: $bg-type-1;
        border-radius: 8px;

        svg {
          width: 36px;

          path {
            fill: white;
          }
        }

        span {
          margin-left: 20px;
          /* 16/SemiBold */
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          /* White */
          color: white;
          mix-blend-mode: normal;
          opacity: 0.9;
        }
      }

      .box-content {
        padding: 24px;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .box-text {
          width: 100%;
          font-size: 14px;
          line-height: 17px;
          /* Text/type0 */
          color: $text-type-0;
          mix-blend-mode: normal;
          opacity: 0.9;
        }
        .subdomain-input {
          margin-top: 24px;
          width: 100%;
          label {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;
            .label {
              margin-left: 14px;
              width: 100%;
              /* 12/Bold */
              font-weight: bold;
              font-size: 12px;
              line-height: 15px;
              /* Text/type1 */
              color: #8786ab;
            }
            input {
              margin-top: 6px;
              margin-left: 3px;
              padding: 13px 11px;
              //width: 100%;
              flex: 1;
              /* Purple-dark */
              background: $purple-dark;
              /* Purple-stroke */
              border: 1px solid $purple-stroke;
              box-sizing: border-box;
              border-radius: 5px;
              outline: none;
              //border: none;
              color: $text-type-0;
              /* 14/Regular */
              font-size: 14px;
              line-height: 17px;
              &:focus {
                outline: none;
                //border: 1px solid $purple;
              }
              &::placeholder {
                color: $text-type-2;
                /* 14/Regular */
                font-size: 14px;
                line-height: 17px;
              }
            }
          }
        }
        button {
          margin-top: 18px;
          padding: 9px 30px;
          &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
        }
      }
    }
  }
}
@media (max-width: 600px) {
  .table-container {
    overflow: auto;
  }
}
</style>
